import React from 'react';
import PageLayout from '../components/global/PageLayout';
import TabBar from '../components/filtering/TabBar';
import ReportsTab from '../components/reports/ReportsTab';
import ExportsTab from '../components/reports/ExportsTab';
import usePersistedTab from '../hooks/global/usePersistedTab';
import { FullTabInt } from '../interfaces';

enum Tab {
  OVERVIEW,
  EXPORTS,
}

const TABS: FullTabInt[] = [
  { id: 'overview', tabId: Tab.OVERVIEW, label: 'Overview' },
  { id: 'exports', tabId: Tab.EXPORTS, label: 'Exports' },
];

export default function ReportsPage() {
  const [tab, onChangeTab] = usePersistedTab({
    defaultTab: Tab.OVERVIEW,
    tabs: TABS,
  });

  const goToExports = React.useCallback(
    () => onChangeTab(Tab.EXPORTS),
    [onChangeTab],
  );

  return (
    <PageLayout title="Reports">
      <TabBar
        currentTab={tab}
        changeTab={onChangeTab}
        noTopMargin
        marginTop={3}
        tabs={TABS.map(t => ({
          ...t,
          component:
            t.tabId === Tab.OVERVIEW ? (
              <ReportsTab onGoToExports={goToExports} />
            ) : (
              <ExportsTab />
            ),
        }))}
      />
    </PageLayout>
  );
}
